import { render, staticRenderFns } from "./vpe_table_dialog.vue?vue&type=template&id=4d3c93f6&lang=pug&"
import script from "./vpe_table_dialog.vue?vue&type=script&lang=coffee&"
export * from "./vpe_table_dialog.vue?vue&type=script&lang=coffee&"
import style0 from "./vpe_table_dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports